import { type IAdvancedRichText } from '../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { type IBaseWidget } from '../../../IBaseWidget.ts';
import { type WidgetType } from '../../../Widget.ts';
import { type IInputWidget } from '../IInputWidget.ts';

/**
 * Input Booleano (Checkbox)
 */
export interface IBooleanWidget extends IInputWidget {
  type: WidgetType.Boolean;
  // value: string;
  text?: IAdvancedRichText; // testo laterale al checkbox
}

export function hasWidgetText<W extends IBaseWidget>(
  widget: W & { text?: IAdvancedRichText },
): widget is W & { text: IAdvancedRichText } {
  return 'text' in widget;
}
